// ═══════════════════════════════════════════════════════════════════════════
// PAGE ADMIN USERS — tri du tableau utilisateurs (pur)
// Extrait de page-admin-users.ts (découpe `renderUsersPage`, 2026-09-27) :
// comparateur PUR (clé et sens passés en paramètres, aucun état de closure).
// Comportement identique à l'inline. Frère de `page-users-row.ts`.
// ═══════════════════════════════════════════════════════════════════════════
//
// Bare refs utilisées (résolues via core-globals.d.ts) : isUserActive.

import type { SortDir, UserEntity, UserSortKey } from './page-admin-users.js';

/** Copie triée de `arr` selon la colonne `sortKey` et le sens `sortDir`.
 *
 * Colonnes Nom / Prénom : mêmes replis que l'affichage (patronyme absent →
 * `name`), sinon une équipe remonterait en tête. `type_trigram` place les
 * équipes avant les individus, puis trie par trigramme. `active` s'appuie sur
 * le helper global `isUserActive` (is_active === false OU départ passé). */
export function sortUsers(
  arr: ReadonlyArray<UserEntity>,
  sortKey: UserSortKey,
  sortDir: SortDir,
): UserEntity[] {
  return [...arr].sort((a, b) => {
    let va: string | number;
    let vb: string | number;
    switch (sortKey) {
      case 'trigram':
        va = (a.trigram || a.name || '').toLowerCase();
        vb = (b.trigram || b.name || '').toLowerCase();
        break;
      case 'type_trigram':
        if (a.is_team !== b.is_team) return a.is_team ? -1 : 1;
        va = (a.trigram || a.name || '').toLowerCase();
        vb = (b.trigram || b.name || '').toLowerCase();
        break;
      case 'last_name':
        va = (a.last_name || a.name || '').toLowerCase();
        vb = (b.last_name || b.name || '').toLowerCase();
        break;
      case 'first_name':
        va = (a.first_name || '').toLowerCase();
        vb = (b.first_name || '').toLowerCase();
        break;
      case 'role':
        va = (a.role || '').toLowerCase();
        vb = (b.role || '').toLowerCase();
        break;
      case 'ext':
        va = a.is_external ? 1 : 0;
        vb = b.is_external ? 1 : 0;
        break;
      case 'teams':
        va = (a.team_ids || []).length;
        vb = (b.team_ids || []).length;
        break;
      case 'email':
        va = (a.email || '').toLowerCase();
        vb = (b.email || '').toLowerCase();
        break;
      case 'active':
        va = isUserActive(a as never) ? 1 : 0;
        vb = isUserActive(b as never) ? 1 : 0;
        break;
      default:
        va = (a.trigram || '').toLowerCase();
        vb = (b.trigram || '').toLowerCase();
    }
    if (va < vb) return sortDir === 'asc' ? -1 : 1;
    if (va > vb) return sortDir === 'asc' ? 1 : -1;
    return 0;
  });
}
